import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map, of } from 'rxjs';
import { memo } from "../util/index.js";
import { getEraCache, setEraCache } from "./cache.js";
import { combineEras, erasHistoricApply, singleEra } from "./util.js";
var CACHE_KEY = 'eraPrefs';

function mapPrefs(era, all) {
  var validators = {};
  all.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        prefs = _ref2[1];

    validators[key.args[1].toString()] = prefs;
  });
  return {
    era: era,
    validators: validators
  };
}

export function _eraPrefs(instanceId, api) {
  return memo(instanceId, function (era, withActive) {
    var _getEraCache = getEraCache(CACHE_KEY, era, withActive),
        _getEraCache2 = _slicedToArray(_getEraCache, 2),
        cacheKey = _getEraCache2[0],
        cached = _getEraCache2[1];

    return cached ? of(cached) : api.query.staking.erasValidatorPrefs.entries(era).pipe(map(function (r) {
      return setEraCache(cacheKey, withActive, mapPrefs(era, r));
    }));
  });
}
export var eraPrefs = singleEra('_eraPrefs');
export var _erasPrefs = combineEras('_eraPrefs');
export var erasPrefs = erasHistoricApply('_erasPrefs');